import { User } from '../../../domain/backoffice/user/User';
import { TableColumn, parseDefaultTableColumns } from '../../shared/tableColumns';

export const usersTableColumnKeys = [
  `email`,
  `external_services`,
  `name`,
  `company`,
  `default_project`,
  `phone`,
  `language`,
  `validation`,
  `created_at`,
] as const;

export type UsersTableColumnKeys = (typeof usersTableColumnKeys)[number];

export type UsersTableColumn = TableColumn<UsersTableColumnKeys, User>;

export const USERS_DEFAULT_TABLE_COLUMNS: Array<UsersTableColumn> = [
  {
    identifier: `email`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `external_services`,
    type: `Array`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `name`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `company`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `default_project`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `phone`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `language`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `validation`,
    type: `boolean`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getUsersTableColumns = (): Array<UsersTableColumn> => {
  const storedTableColumns = localStorage.getItem(`BACKOFFICE_USERS_TABLE_COLUMNS`);
  if (!storedTableColumns) return USERS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<UsersTableColumn> = [...(Array.isArray(parsedTableColumns) ? parsedTableColumns : [])];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: USERS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setUsersTableColumns = (tableColumns: Array<UsersTableColumn>) => {
  localStorage.setItem(`BACKOFFICE_USERS_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
